/**
 * The external dependencies.
 */
import {createAction} from 'redux-actions';

/**
 * Trigger a request to obtain orders and tasks data.
 *
 * @type   {Function}
 * @return {Object}
 */
export const tasksRequest = createAction('tasks/request');
export const setTasksFormatted = createAction('tasks/set-tasksFormatted');
export const resetTasksFormatted = createAction('tasks/reset-tasksFormatted');

export const resetLoading = createAction('tasks/reset-loading');

/**
 * Handle receival of tasks
 *
 * @type   {Function}
 * @param  {Object} tasks
 * @param  {Object} tasks
 * @return {Object}
 */
export const tasksReceive = createAction(
    'tasks/receive',
    ({orders, tasks}) => ({orders, tasks})
);

/**
 * Handle receival of tasks steps
 * @type {[type]}
 */
export const tasksStepsRequest = createAction('tasks/steps-request');

/**
 * Handle receival of tasks steps
 * @type {[type]}
 */
export const tasksStepsReceive = createAction(
    'tasks/steps-receive',
    (steps) => ({steps})
);

export const tasksWorkStepsRequest = createAction('tasks/workSteps-request');


/**
 * Handle receival of tasks steps
 * @type {[type]}
 */
export const tasksWorkStepsReceive = createAction(
    'tasks/workSteps-receive',
    (workSteps) => ({workSteps})
);


export const tasksAllWorkStepsReceive = createAction(
    'tasks/all-workSteps-receive',
    (workSteps) => ({workSteps})
);


/**
 * Handle receival of tasks workplaces
 * @type {[type]}
 */
export const tasksWorkplacesRequest = createAction('tasks/workplaces-request');

/**
 * Handle receival of tasks workplaces
 * @type {[type]}
 */
export const tasksWorkplacesReceive = createAction(
    'tasks/workplaces-receive',
    (workplaces) => ({workplaces})
);


/**
 * Set a task as current
 *
 * @type   {Function}
 * @param  {String} id
 * @return {Object}
 */
export const tasksSelect = createAction(
    'tasks/select',
    (task) => ({task})
);

/**
 * Reset the currenlt selected task
 *
 * @type   {Function}
 * @return {Object}
 */
export const tasksDeselect = createAction('tasks/deselect');

/**
 * Update task data.
 *
 * @type   {Function}
 * @param  {String} id
 * @param  {Object} data
 * @return {Object}
 */
export const tasksUpdate = createAction(
    'tasks/update',
    (id, data) => ({id, data})
);

export const tasksPause = createAction(
    'tasks/pause',
    (id, data) => ({id, data})
);


/**
 * Update task status to reserved.
 *
 * @type   {Function}
 * @param  {String} id
 * @return {Object}
 */
export const tasksReserve = createAction(
    'tasks/reserve',
    (id) => ({id})
);

/**
 * Set the dahsboard grid sorting
 *
 * @type   {Function}
 * @param  {String} sorting
 * @return {Object}
 */
export const tasksSetSorting = createAction(
    'tasks/set-sorting',
    (sorting) => ({sorting})
);

/**
 * Set the dashboard sorting pagination value
 *
 * @type   {Function}
 * @param  {String} paginationValue
 * @return {Object}
 */
export const tasksSetSortingPagination = createAction(
    'tasks/set-current-week',
    (value) => ({value})
);

/**
 * Set the dashboard sorting pagination value
 *
 * @type   {Function}
 * @param  {String} sorting
 * @return {Object}
 */
export const tasksInitSortingPagination = createAction(
    'tasks/init-current-week',
    (sorting) => ({sorting})
);


export const tasksRecievedErrormessage = createAction(
    'tasks/recieved-errormessage',
    (value) => ({value})
);

export const tasksRecievedChildren = createAction(
    'tasks/recieved-children',
    (value) => ({value})
);

export const tasksRecievedInstructions = createAction(
    'tasks/recieved-instructions',
    (value) => ({value})
);

export const tasksRecievedHandbook = createAction(
    'tasks/recieved-handbook',
    (value) => ({value})
);

export const tasksAcceptErrormessage = createAction(
    'tasks/accept-errormessage',
    (task) => ({task})
);

export const tasksErrormessageAccepted = createAction(
    'tasks/errormessage-accepted',
    () => ({})
);

export const tasksReportError = createAction(
    'tasks/reporterror',
    (id, data) => ({id, data})
);

export const setOverlay = createAction(
    'tasks/setOverlay',
    (task, type) => ({task, type})
);

export const resetOverlay = createAction(
    'tasks/resetOverlay',
    (task, type) => ({task, type})
);

export const tasksWorkStarted = createAction(
    'tasks/work-started',
    (task) => ({task})
);

export const setCurrentTracking = createAction(
    'tasks/set-current-tracking',
    (uuid) => ({uuid})
);

export const tasksWorkFinished = createAction(
    'tasks/work-finished',
    () => ({})
);

export const resetCurrentTracking = createAction(
    'tasks/reset-current-tracking',
    (value) => ({})
);

export const getworkstepcount = createAction('tasks/get-workstepcount', () => ({}));
export const setworkstepcount = createAction('tasks/set-workstepcount', (value) => ({value}));
export const setErpFilter = createAction('tasks/set-erp-filter', (filter) => ({filter}));
export const setOrderFilter = createAction('tasks/set-order-filter', (filter) => ({filter}));
export const setCustomFilter = createAction('tasks/set-custom-filter', (filter, value) => ({filter, value}));



// WEBPACK FOOTER //
// ./src/store/tasks/actions.js